export default __webpack_public_path__ + "static/media/HTMATE_Icon.752bc611.png";